// extracted by mini-css-extract-plugin
var _1 = "tjs-timer__background-circle";
var _2 = "tjs-timer__background-circle";
var _3 = "tjs-timer__elapsedTime";
var _4 = "tjs-timer__timer";
export { _1 as "background-circle", _2 as "backgroundCircle", _3 as "elapsedTime", _4 as "timer" }
export default { "background-circle": _1, "backgroundCircle": _2, "elapsedTime": _3, "timer": _4 }
